export default __webpack_public_path__ + "static/media/3.701e15fa.gif";